import { SERVICES } from '../actionTypes';

const initialState = {
  content: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SERVICES.SUCCESS:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};
